import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material"
import { useDispatch, useSelector } from "../../hooks";
import { settingsSet } from "../../redux/actions/settingsSetAction";
import { ISettings } from "../Sessings/Settings";

export enum SortOrder {
    Alpha = 'Alpha',
    CloseDate = 'CloseDate',
    DividendProfitRate = 'DividendProfitRate',
    Delta = 'Delta',
    MaxProfitRate = 'MaxProfitRate',
    DividendCutOffProfitRate = 'DividendCutOffProfitRate',
    ExpirationProfitRate = 'ExpirationProfitRate'
}

export const DEFAULT_SORT_ORDER = SortOrder.MaxProfitRate;

export const Sort = () => {
    const dispatch = useDispatch();
    const settings = useSelector(store => store.settings);

    const handleSort = (sortOrder: SortOrder) => {
        const newSettings: ISettings = {
            sortOrder,
            filterSets: settings.filterSets
        };
        dispatch(settingsSet(newSettings));
    }

    return (
        <FormControl>
            <FormLabel id="sort-setting">Сортировать</FormLabel>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue={ settings.sortOrder }
                name="radio-buttons-group"
                onChange={(event) => handleSort(event.target.value as SortOrder)}
            >
                <FormControlLabel value={ SortOrder.Alpha } control={<Radio />} label="Наименование" />
                <FormControlLabel value={ SortOrder.CloseDate } control={<Radio />} label="Дата закрытия" />
                <FormControlLabel value={ SortOrder.DividendProfitRate } control={<Radio />} label="Див. доходность" />
                <FormControlLabel value={ SortOrder.Delta } control={<Radio />} label="Дельта" />
                <FormControlLabel value={ SortOrder.MaxProfitRate } control={<Radio />} label="Макс. доходность" />
                <FormControlLabel value={ SortOrder.DividendCutOffProfitRate } control={<Radio />} label="Доходность див. отсечки" />
                <FormControlLabel value={ SortOrder.ExpirationProfitRate } control={<Radio />} label="Доходность экспирации" />
            </RadioGroup>
        </FormControl>
    );
}